import {ReloadButton,} from '@flexinet/ui-components';

import {Box,} from '@mantine/core';

import {useOffers} from '../hooks/useOffers.ts';

export const ReloadRecordsButton = () => {

    const {fetchRecords} = useOffers();
    return (
        <Box mx='s'>
            <ReloadButton onClick={() => fetchRecords()}/>
        </Box>
    );
};